import t from 'ember-intl/helpers/t';

import Window from 'umg-ember-backend/components/ui/window';

<template>
  <Window>
    <:body>
      <div class='o-error-page'>
        {{#if @model.errors}}
          {{#each @model.errors as |error|}}
            <div
              class='o-error-page__status'
              data-test-error-page-status
            >{{error.status}}</div>
            <div class='o-error-page__title'>{{error.title}}</div>
            {{error.detail}}
          {{/each}}
        {{else}}
          <div class='o-error-page__status' data-test-error-page-status>{{t
              'error.error_404.status'
            }}</div>
          <div class='o-error-page__title'>{{t 'error.error_404.title'}}</div>
          {{t 'error.error_404.detail'}}
        {{/if}}
      </div>
    </:body>
  </Window>
</template>
